<template>
  <button
    type="button"
    class="relative inline-flex flex-shrink-0 cursor-pointer rounded-full transition-colors duration-200 ease-in-out focus:outline-none"
    :class="[value ? `bg-${color}` : 'bg-neutral-50', size.track]"
    style="padding-top: 1.5px; padding-left: 2px;"
    role="switch"
    aria-checked="false"
    @click="updateValue"
  >
    <span
      :class="{
        'translate-x-5': value,
        'translate-x-0': !value
      }"
      :style="{
        width: `${size.knob}px`,
        height: `${size.knob}px`,
        transform: `translateX(${value ? size.travel : 0}px)`
      }"
      class="pointer-events-none relative inline-block transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
    />
  </button>
</template>

<script>
export default {
  name: 'BaseToggle',
  props: {
    // Model
    value: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: 'green-500'
    },
    small: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    // Track classes, knob size and knob travel (px) for each size
    size () {
      if (this.small) return { track: 'w-7 h-4', knob: 13, travel: 11 }
      if (this.medium) return { track: 'w-9 h-5', knob: 16, travel: 16 }
      return { track: 'w-11 h-6', knob: 20, travel: 20 }
    }
  },
  methods: {
    // Update Model Value
    updateValue () {
      this.$emit('toggle')
    }
  }
}
</script>

<style scoped lang="css">
</style>
